module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('invoice-summary'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "align": "center",
      "span": 24
    }
  }, [_c('data-table', {
    attrs: {
      "title": "Financial Statement",
      "url": "report/finance/summary",
      "table-ref": "finance-summary",
      "show-search": false,
      "show-refresh": true,
      "track-by": "name",
      "fields": _vm.fields
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54ae276a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/finance/StatementView.vue
// module id = 1570
// module chunks = 0